const SET_ACCOUNT = 'setAccount'
const SET_ACCOUNTS = 'setAccounts'
const SET_ACCOUNT_FILA = 'setAccountFila'
const SET_ACCOUNTS_FILA = 'setAccountsFila'

export const mutationTypes = {
  SET_ACCOUNT,
  SET_ACCOUNTS,
  SET_ACCOUNT_FILA,
  SET_ACCOUNTS_FILA
}

export const mutations = {
  [SET_ACCOUNT] (state, payload) {
    state.account = payload
  },

  [SET_ACCOUNTS] (state, payload) {
    state.accounts = payload
  },
  [SET_ACCOUNT_FILA] (state, payload) {
    state.accountFila = payload
  },
  [SET_ACCOUNTS_FILA] (state, payload) {
    state.accountsFila = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/account/mutations.js